// Locked feature → the plan that unlocks it (owner 2026-10-04: a locked surface goes straight to /pricing, which shows
// this notice and highlights the plan — no separate upsell page that could drift from the published plans).
export const FEATURE_PLAN: Record<string, { label: string; plan: 'standard' | 'pro' | 'institutional' }> = {
  'detailed-analysis': { label: 'Detailed Analysis', plan: 'standard' },
  detailed_analysis: { label: 'Detailed Analysis', plan: 'standard' },
  'risk-kernel': { label: 'Risk Kernel', plan: 'standard' },
  risk_kernel: { label: 'Risk Kernel', plan: 'standard' },
  reports: { label: 'Reports', plan: 'standard' },
  report: { label: 'Institutional Report generation', plan: 'standard' },
  ecosystem: { label: 'Ecosystem Impact', plan: 'standard' },
  portfolio: { label: 'Portfolio analytics', plan: 'pro' },
  scenario: { label: 'Asset Scenarios & Risk Limits', plan: 'standard' },
  asset: { label: 'Wider asset coverage', plan: 'standard' },
};

export const pricingPathFor = (feature?: string) => (feature ? `/pricing?feature=${encodeURIComponent(feature)}#plans` : '/pricing#plans');
